import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MainLayoutFixed from './MainLayoutFixed';
import ThemeErrorBoundary from '../../theme/ThemeErrorBoundary';
import { StyledComponentsIntegration } from '../../theme/StyledComponentsIntegration';
import { FloatingAgentButton } from '../ai-agent/FloatingAgentButton';
import { ChatModal } from '../ai-agent/ChatModal';
import { useAIAgent } from '../../context/AIAgentContext';
import { useKeyboardShortcuts } from '../../hooks/useKeyboardShortcuts';

/**
 * MainLayoutWrapper
 * 
 * This component wraps the MainLayout component with the StyledComponentsIntegration
 * to ensure that styled-components has access to the theme.
 */
const MainLayoutWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isVisible, hideAgent, updateContext } = useAIAgent();
  const location = useLocation();
  
  // Enable keyboard shortcuts
  useKeyboardShortcuts();
  
  // Update page context when location changes
  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const pageType = pathSegments[0] || 'dashboard';
    
    updateContext({
      pageType,
      currentPath: location.pathname,
      timestamp: new Date().toISOString(),
    });
  }, [location.pathname, updateContext]);
  
  return (
    <ThemeErrorBoundary>
      <StyledComponentsIntegration>
        <MainLayoutFixed>
          {children}
        </MainLayoutFixed>
        
        {/* AI Agent components */}
        <FloatingAgentButton />
        <ChatModal
          open={isVisible}
          onClose={hideAgent}
        />
      </StyledComponentsIntegration>
    </ThemeErrorBoundary>
  );
};

export default MainLayoutWrapper;